/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  arrayOf,
  func,
  string,
} from 'prop-types';
import Small from './Small';
import './TabFilterSettings.scss';

class TabFilterSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      tabWidth: 0,
    };
    this.tab = React.createRef();
    this.tabs = React.createRef();
  }

  onTabClickWithIndex = (i, tab) => {
    const { onChange } = this.props;
    if (onChange) onChange(i, tab);
    this.setState({
      selectedIndex: i,
      tabWidth: this.tab.current.offsetWidth,
    });
  };

  render() {
    const {
      selectedIndex,
      tabWidth,
    } = this.state;
    const {
      tabs,
    } = this.props;
    return (
      <div className="anchor-tabs" ref={this.tabs}>
        <div className="border-wrapper">
          <div className="container-wrapper">
            <div className="row-wrapper">
              <div className="col-wrapper tab-filter-content">
                {tabs.map((tab, i) => (
                  <div
                    className="anchor-tab"
                    style={{
                      minWidth: `${1 / tabs.length * 100}%`,
                      flexBasis: `${1 / tabs.length * 100}%`,
                    }}
                    key={tab}
                    onClick={() => this.onTabClickWithIndex(i, tab)}
                    ref={this.tab}
                  >
                    <Small>
                      {(selectedIndex === i)
                        ? <strong className="anchor-tab-active">{tab}</strong>

                        : <span className="anchor-tab-inactive">{tab}</span>
                      }
                    </Small>
                    {i === 0 && (
                      <div
                        className="anchor-tab-active-cursor"
                        style={
                          { transform: `translateX(${selectedIndex * (tabWidth - 1)}px)` }
                        }
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TabFilterSettings.defaultProps = {
  tabs: [],
  onChange: undefined,
};

TabFilterSettings.propTypes = {
  /** Array of strings used as tab labels */
  tabs: arrayOf(string),
  /** Pass in function to trigger when a tab is pressed */
  onChange: func,
};

export default TabFilterSettings;
